
import { l, tryGetTokenOverride, selectLanguage } from "./localization.js";


// Artist pages in encyclopedia
export const artists = {


    
    entry(number, locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "entry");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        switch(number) {
            case 1: return l.app.pages.artists.singular(locale);
            default: return l.app.pages.artists.plural(locale);
        }
            
    },
            

    
    singular(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "singular");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de", "fr"]);

        switch (language) {
            case "en": return "Artist";
            case "de": return "Künstler";
            case "fr": return "Artiste";
            default: return `[singular: ${language} missing]`;
        }
    
    },
            

    
    plural(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "plural");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de", "fr"]);

        switch (language) {
            case "en": return "Artists";
            case "de": return "Künstler";
            case "fr": return "Artistes";
            default: return `[plural: ${language} missing]`;
        }
    
    },
            
};
